export const roundToFixed = (num: number, decimalPlaces: number) => {
  const div = Math.pow(10, decimalPlaces);
  return Math.round(num * div) / div;
};
